import styled from 'styled-components';
import { getSpacing } from 'stylesheet';
export var NavigationHeaderContainer = styled.div.withConfig({
  displayName: "NavigationHeaderstyle__NavigationHeaderContainer",
  componentId: "sc-gdhbdn-0"
})(["display:inline-flex;align-items:center;padding:0 ", ";"], getSpacing(2));
export var TabsContainer = styled.div.withConfig({
  displayName: "NavigationHeaderstyle__TabsContainer",
  componentId: "sc-gdhbdn-1"
})(["display:inline-flex;justify-content:center;"]);